<template>
  <jz-container class="course-card">
    <jz-container class="image">
      <img :src="course.image" />
    </jz-container>
    <jz-container class="title">{{ course.title }}</jz-container>
  </jz-container>
</template>
<script>
export default {
  name: "CourseCard",
  props: {
    course: { type: Object, required: true }
  }
};
</script>
<style lang="scss">
.course-card {
  border-radius: $gutter/2;
  min-height: 292px;
  height: max-content;
  width: 210px;
  cursor: pointer;
  display: inline-block;
  margin: 0px;

  &:hover {
    background: var(--color-secondary-background-light);
  }

  .title {
    color: var(--color-dark);
    font-size: $font-size-base;
    font-weight: bold;
    padding: $gutter;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .image {
    overflow: hidden;
    border-radius: $gutter * 3 / 4;
    height: 180px;
    width: 180px;
    margin: auto;
    margin-top: $gutter/2;

    img {
      object-fit: cover;
      height: 180px;
      width: 180px;
    }
  }
}
</style>
